import {
  AppBar,
  Logout,
  MenuItemLink,
  UserMenu,
  useGetIdentity,
  useSidebarState,
} from "react-admin";

import { Avatar, Tooltip, Typography, Box } from "@mui/material";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

import { COLLAPSED_WIDTH, SIDEBAR_WIDTH } from "@/constants/resources";

import { useMemo } from "react";

const MyCustomIcon = () => {
  const { identity } = useGetIdentity();

  const { initials, pseudo } = useMemo(() => {
    const displayName =
      typeof identity?.pseudo === "string"
        ? identity.pseudo
        : typeof identity?.fullName === "string"
          ? identity.fullName
          : "";

    const initials = displayName
      ? displayName
          .trim()
          .split(/\s+/)
          .map((p) => p[0])
          .join("")
          .slice(0, 2)
          .toUpperCase()
      : "";

    return {
      initials,
      pseudo: displayName,
    };
  }, [identity]);

  return (
    <Tooltip title={pseudo || ""}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 1,
          py: 0.5,
          borderRadius: 999,
          bgcolor: "transparent",
        }}
      >
        <Avatar
          sx={{
            width: 30,
            height: 30,
            fontSize: 14,
            bgcolor: "#6C0088",
            color: "#fff",
          }}
        >
          {initials || "?"}
        </Avatar>

        <Typography
          variant="body2"
          sx={{
            maxWidth: 140,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "#6C0088",
            fontWeight: 600,
          }}
        >
          {pseudo || "User"}
        </Typography>
      </Box>
    </Tooltip>
  );
};

const CustomAppBar = () => {
  const [open] = useSidebarState();

  return (
    <AppBar
      sx={{
        width: `calc(100% - ${open ? SIDEBAR_WIDTH : COLLAPSED_WIDTH}px)`,

        ml: `${open ? SIDEBAR_WIDTH : COLLAPSED_WIDTH}px`,

        backgroundColor: "#fff",
        boxShadow: "none",
        borderBottom: "1px solid #e0e0e0",

        "& .RaAppBar-toolbar": {
          padding: "15px",
          justifyContent: "flex-end",
        },

        "& .RaAppBar-toolbar .RaRefreshButton": {
          display: "none",
        },

        "& .MuiIconButton-root": {
          color: "#6C0088",
        },
      }}
      userMenu={
        <UserMenu icon={<MyCustomIcon />}>
          <MenuItemLink
            to="/profile"
            primaryText="Mon profil"
            leftIcon={<AccountCircleOutlinedIcon />}
          />

          <Logout />
        </UserMenu>
      }
    />
  );
};

export default CustomAppBar;
